export const KODE_WILAYAH_NASIONAL = '360'
export const KODE_WILAYAH_NASIONAL_FOR_TRACKER = '000000'
export const KODE_WILAYAH_LUAR_NEGERI = '350000'
export const DEFAULT_LOGO = 'logo-kemdikbud.webp'
export const PROVINCES_LOGO_BY_CODE: Record<string, string> = {
  '100000': 'jambi.png',
  '110000': 'sumsel.png',
  '120000': 'lampung.png',
  '130000': 'kalbar.png',
  '140000': 'kalteng.png',
  '150000': 'kalsel.png',
  '160000': 'kaltim.png',
  '170000': 'sulut.png',
  '180000': 'sultengah.png',
  '190000': 'sulsel.png',
  '200000': 'sultenggara.png',
  '210000': 'maluku.png',
  '220000': 'bali.png',
  '230000': 'ntb.png',
  '240000': 'ntt.png',
  '250000': 'papua.png',
  '260000': 'bengkulu.png',
  '270000': 'maluku-utara.png',
  '280000': 'banten.png',
  '290000': 'bangka-belitung.png',
  '300000': 'gorontalo.png',
  '310000': 'kep-riau.png',
  '320000': 'papua-barat.png',
  '330000': 'sulbar.png',
  '340000': 'kalut.png',
  '360000': 'papua-tengah.png',
  '370000': 'papua-selatan.png',
  '380000': 'papua-pegunungan.png',
  '390000': 'papua-barat-daya.png',
  '010000': 'jakarta.png',
  '020000': 'jawa-barat.png',
  '030000': 'jawa-tengah.png',
  '040000': 'yogyakarta.png',
  '050000': 'jawa-timur.png',
  '060000': 'aceh.png',
  '070000': 'sumut.png',
  '080000': 'sumbar.png',
  '090000': 'riau.png',
  '350800': 'countries/arab.png',
  '350100': 'countries/belanda.png',
  '351500': 'countries/brunei.png',
  '351400': 'countries/china.png',
  '350600': 'countries/filipina.png',
  '350200': 'countries/jepang.png',
  '350400': 'countries/malaysia.png',
  '350300': 'countries/mesir.png',
  '350500': 'countries/myanmar.png',
  '351000': 'countries/singapura.png',
  '351300': 'countries/taiwan.png',
  '351200': 'countries/thailand.png',
  '350700': 'countries/rusia.png',
}
